export default "__VITE_ASSET__C41jz1ya__"